import { AEMErrorMessage } from '../../../models';

export const AccountActivityErrorMocks: AEMErrorMessage = {
  action: {
    id: '',
    label: '',
    url: ''
  },
  component: 'activity',
  errorId: [
    {
      errorCode: '0000'
    },
    {
      errorCode: '0016'
    },
    {
      errorCode: '0035'
    },
    {
      errorCode: '2110'
    }
  ],
  errorMessageDescription:
    'Sorry, we’re currently unable to display Your activities. Please try again later.',
  errorMessageTitle: '',
  featureTitle: '',
  icon: {
    alt: 'alert',
    src: '/content/dam/delta-applications/ui-kit/assets/svg/alerts/alert-red-invert.svg'
  },
  type: 'single-error'
};
